export default [
  {
    name: 'upload',
    base: {
      url: '/Aerscreen/Upload',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true
    }
  },
  {
    name: 'downloadTemplate',
    base: {
      url: '/Aerscreen/DownloadTemplate',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {}
  },
  {
    name: 'importSources',
    base: {
      url: '/Aerscreen/ImportSources',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true
    }
  },
  {
    name: 'transformAsz',
    base: {
      url: '/Aerscreen/TransformAsz',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true
    }
  },
  {
    name: 'transformInp',
    base: {
      url: '/Aerscreen/TransformInp',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true
    }
  },
  {
    name: 'getParams',
    base: {
      url: '/Aerscreen/GetParams',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true
    }
  },
  {
    name: 'searchPollutants',
    base: {
      url: '/Aerscreen/Pollutants/Search',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      allowArrayResponse: true,
      timeout: 15000
    }
  },
  {
    name: 'calculate',
    base: {
      url: '/Aerscreen/Aerscreen',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      timeout: 180000
    }
  },
  {
    name: 'submitTask',
    base: {
      url: '/Aerscreen/SubmitTask',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      timeout: 0
    }
  },
  {
    name: 'submitElasticTaskFromAsz',
    base: {
      url: '/Aerscreen/SubmitElasticTask/Asz',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      timeout: 0
    }
  },
  {
    name: 'submitElasticTask',
    base: {
      url: '/Aerscreen/SubmitElasticTask',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      timeout: 0
    }
  },
  {
    name: 'submitElasticTaskFromInputFiles',
    base: {
      url: '/Aerscreen/SubmitElasticTask/InputFiles',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      timeout: 0
    }
  },
  {
    name: 'getTaskStatus',
    base: {
      url: '/Aerscreen/Task/',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      timeout: 15000
    }
  },
  {
    name: 'getTaskResult',
    base: {
      url: '/Aerscreen/Result/',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      timeout: 30000
    }
  },
  {
    name: 'getElasticTaskStatus',
    base: {
      url: '/Aerscreen/ElasticTask/',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      timeout: 15000
    }
  },
  {
    name: 'getElasticTaskResult',
    base: {
      url: '/Aerscreen/ElasticResult/',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      timeout: 30000
    }
  },
  {
    name: 'calculateFromFiles',
    base: {
      url: '/Aerscreen/AerscreenInput',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      timeout: 180000
    }
  },
  {
    name: 'debugCalculate',
    base: {
      url: '/Aerscreen',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true
    }
  },
  {
    name: 'downloadReport',
    base: {
      url: '/Aerscreen/DownloadReport',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {}
  },
  {
    name: 'cancelRun',
    base: {
      url: '/Aerscreen/Cancel/',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      timeout: 15000
    }
  },
  {
    name: 'cancelTask',
    base: {
      url: '/Aerscreen/CancelTask/',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {
      allowPlainObjectResponse: true,
      timeout: 15000
    }
  }
]
